export const environment = {
  production: true,
  appVersion: 'V2.1',
  USERDATA_KEY: 'authf916cf5a5f68',
  swFilePath: '',
  isMockEnabled: false,
  apiUrl: 'https://thynk-api.santechture.com/services',
  adminAPIUrl: 'https://thynk-api.santechture.com/admin',
  apiUrlRules: 'https://thynk-api.santechture.com/thynk-rule-files',

  apiUrlForAdmin: 'https://thynk-api.santechture.com',
  apiUrlIntegration: 'https://thynk-api.santechture.com/integ',

  // pdfUrl:
  //   'https://stage-api.santechture.com/codemap/services/account/download-transaction',
  uploadUrl: 'https://stage-files.santechture.com',
  clientUrl: 'https://stage-www.santechture.com/client',
  backendBaseImageUrl: 'https://am-files.santechture.com',

};
